export default __webpack_public_path__ + "static/media/lab-logo.d34deb2c.svg";